import { Tag } from 'antd';
// helpers

const TagCell: React.FC = (version: string) => {

  if (!version) return null

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        <Tag color="default">V{version}</Tag>
      </div>
    </div>
  )
}

export default TagCell
